import React from 'react';
import moment from 'moment';

import {
  availableBanTimes,
} from '../lib/helpers';

import {
  canBan,
  canKenta,
} from '../lib/policies';

import {
  useModal,
} from '../hooks';

import ModalDelete from './ModalDelete';
import UserNoteEditModal from './UserNoteEditModal';
import LiftBanModal from './LiftBanModal';
import ClearBanHistoryModal from './ClearBanHistoryModal';

const UserPenaltyTools = ({
  isBanned,
  isShadowBanned,
  userId,
  uuid,
  banUntil,
  bannedTimeLeft,
  shadowBanUntil,
  shadowBannedTimeLeft,
  type,
}) => {
  if (!canKenta('User')) {
    return null
  }

  const [
    modal,
    modalSet,
  ] = useModal()  // UserNoteEditModal has its own way of keyboard bindings.

  return (
    <React.Fragment>
      <div className='Table Table--user-4'>
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>Field</div>
          <div className='Table__col Table__col--th'>Value</div>
        </div>

        {!isShadowBanned &&
          <div className='Table__row'>
            <div className='Table__col'>Shadow Ban</div>
            <div className='Table__col'>
              <div className='Table__ban-temporary'>
                <a
                  className='Badge Badge--orange Badge--icon-lock'
                  onClick={() => { modalSet('shadow_ban') }}
                >
                  30 DAYS
                </a>
              </div>
            </div>
          </div>
        }

        {isShadowBanned &&
          <div className='Table__row'>
            <div className='Table__col'>Unshadow Ban</div>
            <div className='Table__col'>
              <ul className='Table__ban-permanent'>
                <li className='Table__ban-permanent__li'>
                  <LiftBanModal
                    id={userId}
                    action={'lift_shadow_ban'}
                  />
                </li>
              </ul>
            </div>
          </div>
        }

        {isShadowBanned &&
          <div className='Table__row'>
            <div className='Table__col'>Shadow Banned until</div>
            <div className='Table__col'>
              <div className='Table__ban-until'>
                <time>{moment(shadowBanUntil).format('YYYY-MM-DD HH:mm')}</time>
                <span>({shadowBannedTimeLeft})</span>
              </div>
            </div>
          </div>
        }

        {!isBanned &&
          <div className='Table__row'>
            <div className='Table__col'>Temporary</div>
            <div className='Table__col'>
              <div className='Table__ban-temporary'>
                {availableBanTimes.map((x, i) => (
                  <a
                    key={i}
                    className='Badge Badge--orange Badge--icon-lock'
                    onClick={() => {
                      modalSet(x.key)
                    }}
                  >
                    {x.value}
                  </a>
                ))}
              </div>
            </div>
          </div>
        }

        {isBanned &&
          <div className='Table__row'>
            <div className='Table__col'>Unban</div>
            <div className='Table__col'>
              <ul className='Table__ban-permanent'>
                <li className='Table__ban-permanent__li'>
                  <LiftBanModal
                    id={userId}
                  />
                </li>
                <li className='Table__ban-permanent__li'>
                  <ClearBanHistoryModal
                    id={userId}
                  />
                </li>
              </ul>
            </div>
          </div>
        }

        {isBanned &&
          <div className='Table__row'>
            <div className='Table__col'>Banned until</div>
            <div className='Table__col'>
              <div className='Table__ban-until'>
                <time>{moment(banUntil).format('YYYY-MM-DD HH:mm')}</time>
                <span>({bannedTimeLeft})</span>
                <a
                  className='Table__ban-until__a'
                  onClick={() => {
                    modalSet('specific')
                  }}
                >
                  Edit date
                </a>
              </div>
            </div>
          </div>
        }

        {canBan('User') &&
          <div className='Table__row'>
            <div className='Table__col'>Permanent</div>
            <div className='Table__col'>
              <ul className='Table__ban-permanent'>
                <li className='Table__ban-permanent__li'>
                  <a
                    className='Badge Badge--red Badge--icon-no-entry'
                    onClick={() => {
                      modalSet('permanent')
                    }}
                  >
                    Ban
                  </a>
                </li>

                <li className='Table__ban-permanent__li'>
                  <ModalDelete
                    type='user'
                    id={userId}
                  />
                </li>
              </ul>
            </div>
          </div>
        }
      </div>

      <UserNoteEditModal
        isActive={modal}
        isBanning
        isBanningEdit={isBanned}
        onToggleModal={() => {
          modalSet(false)
        }}
        userId={userId}
        bannedTimeLeft={bannedTimeLeft}
        banTime={modal}
        banUntil={banUntil}
        type={type}
        uuid={uuid}
      />
    </React.Fragment>
  )
}

export default UserPenaltyTools
